var map = {
	"./basics1.png": 9881,
	"./basics2.png": 9170,
	"./basics3.png": 7035,
	"./basics4.png": 5380,
	"./basics5.png": 1677,
	"./basics6.png": 54,
	"./basicsBanner.png": 3132,
	"./fruity1.png": 8039,
	"./fruity2.png": 7980,
	"./fruity3.png": 7077,
	"./fruityBanner.png": 702,
	"./specialty1.png": 8738,
	"./specialty10.png": 5800,
	"./specialty2.png": 9705,
	"./specialty3.png": 1584,
	"./specialty4.png": 6559,
	"./specialty5.png": 9622,
	"./specialty6.png": 3597,
	"./specialty7.png": 9700,
	"./specialty8.png": 9923,
	"./specialty9.png": 5818,
	"./specialtyBanner.png": 7713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4956;